import { Check, Remove } from '@mui/icons-material';
import { Box, BoxProps, Typography } from '@mui/material';
import { green, red } from '@mui/material/colors';

import { PasswordRequirement } from '../types';
import { validatePassword } from '../utils';

const PasswordStrengthChecker: React.FC<BoxProps & { password: string }> = ({
  password,
  ...props
}) => {
  const { requirements } = validatePassword(password);

  const renderRequirement = (requirement: PasswordRequirement, key: number) => (
    <Box key={key}>
      <Typography
        variant="body2"
        sx={{
          fontSize: 12,
          color: requirement.valid ? green[500] : red[500],
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {requirement.valid ? (
          <Check sx={{ fontSize: 12, marginRight: 0.5 }} />
        ) : (
          <Remove sx={{ fontSize: 12, marginRight: 0.5 }} />
        )}
        <span>{requirement.text}</span>
      </Typography>
      {requirement.children && (
        <Box sx={{ marginLeft: 2 }}>
          <span>{requirement.children.map(renderRequirement)}</span>
        </Box>
      )}
    </Box>
  );

  if (!requirements.length) {
    return null;
  }

  return (
    <Box sx={{ ml: 1.5 }} {...props}>
      {requirements.map(renderRequirement)}
    </Box>
  );
};

export default PasswordStrengthChecker;
